import "../../scss/style.scss";
import { init } from "./bootstrap";
document.addEventListener("DOMContentLoaded", init);
